import { Box, Menu, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useGetLoggedInUserDetails } from "../../aAdminTabTeam2/hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { clearAuthData } from "../../aAdminTabTeam2/hooksAndFunctions/functions/clearAuthData";
import { signOut } from "../../common/signout/signout";
import { getFullName, getInitialsFromName } from "../../helpers/utils";
import { MuiTypography } from "../typography/MuiTypography";
import { HeaderProfileWrapper } from "./HeaderProfile.style";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";
export const HeaderProfile = () => {
  const { loggedInUser } = useGetLoggedInUserDetails();
  const { commonARIALabel } = useNavigationSiteCore();

  const [userInitials, setUserInitials] = useState("");
  const [fullName, setFullName] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (Object.keys(loggedInUser ?? "").length) {
      const firstName = loggedInUser?.firstName ?? "";
      const lastName = loggedInUser?.lastName ?? "";
      setUserInitials(getInitialsFromName(firstName, lastName));
      setFullName(getFullName(firstName, lastName));
    }
  }, [loggedInUser]);
  return (
    <HeaderProfileWrapper>
      <Box className="nameContainer" tabIndex={0}>
        <MuiTypography variant="h4Bold" className="profileNameDesktop">
          {fullName}
        </MuiTypography>
        {/* <MuiTypography
          variant="body2"
          component="span"
          className="lastLoginDesktop"
        >
          Last Login 17:15
        </MuiTypography> */}
      </Box>
      <Box
        className="initialNameBg"
        onClick={handleMenu}
        tabIndex={0}
        aria-label={commonARIALabel.openProfileMenu}
        role="button"
      >
        <MuiTypography variant="body2" className="initialName" component="div">
          {userInitials}
        </MuiTypography>
      </Box>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            signOut();
            clearAuthData();
          }}
        >
          Sign out
        </MenuItem>
      </Menu>
    </HeaderProfileWrapper>
  );
};
